var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobSummaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7928 7.51491L17.0884 8.65943M11.872 10.9321L14.0198 11.5043M11.9789 17.3698L12.838 17.5987C15.2679 18.2461 16.4829 18.5698 17.4401 18.0204C18.3972 17.4708 18.7228 16.2627 19.3739 13.8464L20.2947 10.4293C20.9458 8.01305 21.2714 6.80491 20.7188 5.85315C20.1662 4.90138 18.9512 4.57766 16.5212 3.93022L15.662 3.70132C13.2321 3.05387 12.0171 2.73016 11.06 3.27967C10.1028 3.82917 9.77721 5.0373 9.1261 7.45357L8.20529 10.8707C7.55418 13.2869 7.22863 14.4951 7.78125 15.4468C8.33387 16.3987 9.54886 16.7224 11.9789 17.3698Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.0517L11.1429 20.2851C8.71863 20.9452 7.5065 21.2752 6.55158 20.715C5.59666 20.1547 5.27186 18.9229 4.62228 16.4592L3.70364 12.9751C3.05406 10.5114 2.72926 9.27956 3.2806 8.30912C3.75751 7.46966 4.8 7.50023 6.15 7.50012",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSummaryIcon);
export default __webpack_public_path__ + "static/media/job_summary_icon.48f9e4d5600df0eb7d94a9aac573f620.svg";
export { ForwardRef as ReactComponent };